import { InjectionToken } from '@angular/core';

export interface CookieConsentConfig {
  readonly measurementId?: string;
}

export const COOKIE_CONSENT_CONFIG = new InjectionToken<CookieConsentConfig>('CookieConsentConfig');
